/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import Tag_img from "../../assets/webSeries/tag_img.png";
import { BiRightArrowAlt } from "react-icons/bi";
import CustomPlaybutton from "../../components/Buttons/CustomPlaybutton";
import desktop_bg from "../../assets/Detailpage/bg.png";
import bg from "../../assets/bg_image/banner.png";

import "./Category.css";
import YoutubeEmbed from "../../components/YoutubeEmbedDetailPage";
import { longFormatData, shortsAndDocData } from "../../data/data";
import { useWindowSize } from "react-use";
const Detail = ({ pageHeading }) => {
  const { width } = useWindowSize();
  const { videoId } = useParams();

  const allData = [...longFormatData, ...shortsAndDocData];

  const videoDetails = allData?.find((video) => {
    return video.videoId === videoId;
  });

  const moreinfodata = [
     {
      id: 1,
      title: "DIRECTORS",
      description: videoDetails?.Director || "--",
    },
    {
      id: 2,
      title: "STARRING",
      description: videoDetails?.Starring || "--",
    },
    {
      id: 3,
      title: "SUBTITLES",
      description: "English",
    },
    {
      id: 4,
      title: "STUDIO",
      description: "RAT Films",
    },
     {
      id: 5,
      title: "CONTENT ADVISORY",
      description: "Foul language",
    },
  ];

  return (
    <div className="w-full h-full">
      <div
        className={`w-full flex-col tab:flex-row font-montserrat overflow-hidden tab:h-screen px-4 py-6 md:px-[7.2vw] md:py-[4.7vw] relative flex md:justify-start md:items-end`}
      >
        <div className="h-[20%] z-[1] absolute pointer-events-none left-0 right-0 top-0 bg-gradient-to-b from-black/10 to-transparent md:from-black"></div>

        <div className="top-0 pointer-events-none left-0 px-4 absolute md:px-[7.2vw] z-10 flex items-center pt-[25vw] md:pt-[10.29vw]">
          <Pageheading
            pageHeading={pageHeading || videoDetails?.name}
            icon={<RiHome2Line />}
          />
        </div>

        <div className="aspect-video w-full tab:aspect-full tab:absolute tab:inset-0 h-full tab:bg-black mt-[30%] md:mt-[15%] tab:mt-0">
          <YoutubeEmbed
            videoId={videoDetails?.videoId}
            thumbnail={videoDetails?.background}
            mobileThumbnail={videoDetails?.background}
            iframecss="w-full aspect-video tab:absolute tab:top-1/2 tab:-translate-y-1/2"
            iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
          />
        </div>

        <div className="mt-8 tab:mt-0 w-full z-10 text-center tab:text-left tab:w-[60%] xl:w-[45%] pointer-events-none">
          <p className="font-bold text-26 capitalize leading-[26px] sm:text-[32px]  sm:leading-[34px] 3xl-plus:text-[45px] 3xl-plus:leading-[45px] text-green-end">
            {videoDetails?.name}
          </p>
          <div className="flex gap-4 items-center justify-center tab:justify-start mt-4 sm:mt-8">
            {videoDetails?.type && (
              <>
                <p className="font-semibold  text-14  leading-[14px] sm:text-24 sm:leading-[24px] 3xl-plus:text-[30px] 3xl-plus:leading-[30px] text-white capitalize">
                  {videoDetails?.type}
                </p>
                <div className="size-2 rounded-full bg-white/50"></div>
              </>
            )}

            <p className="font-semibold  text-14  leading-[14px] sm:text-24 sm:leading-[24px] 3xl-plus:text-[30px] 3xl-plus:leading-[30px] text-white">
              {videoDetails?.year}
            </p>
            {videoDetails.seasons && (
              <>
                <div className="size-2 rounded-full bg-white/50"></div>
                <p className="font-semibold text-14  leading-[14px] sm:text-24 sm:leading-[24px] 3xl-plus:text-[30px] 3xl-plus:leading-[30px] text-white">
                  {`${videoDetails?.seasons} Season`}
                </p>
              </>
            )}
          </div>
          <p className="sm:mt-6 mt-4 text-16 leading-[26px] sm:leading-[22px] sm:text-18 3xl-plus:leading-[30px] 3xl-plus:text-[25px] text-white font-light">
            {videoDetails?.desc}
          </p>
        </div>

        <div className="h-[20%] z-[2] pointer-events-none absolute left-0 right-0 bottom-0 bg-gradient-to-b from-transparent to-black/10 md:to-black"></div>
      </div>

      {/* More Info Section */}
      <section className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] pb-[50px] w-full h-full relative">
        <h2 className="text-left w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          MORE INFO
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 tab:grid-cols-3 gap-10 md:gap-12 mt-8">
          {moreinfodata.map((item) => (
            <div key={item.id} className="text-left">
              <p className="text-white 3xl-plus:text-[28px] md:text-[24px] font-montserrat text-[20px] font-medium uppercase">
                {item.title}
              </p>
              <p className="text-[16px] text-white mt-[16px] md:mt-[18px] md:text-[22px] 3xl-plus:text-[26px] font-montserrat font-light">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Detail;
